import React, {useState,useEffect} from 'react'
import clinicService from '../../../../../services/clinic.service'
import { useEyeconxStore } from '../../../../../store/eyeconxStore'
import Loading from '../../../../common/Loading'
import CustomizationForm from './CustomizationForm'
import { useParams } from 'react-router-dom'
function CustomizationTab() {

    const {clinicId} = useParams();
    const [customization, setCustomization] =useState([])
    const [loading,setLoading] = useState(false)
    const [isEditing,setIsEditing] = useState(false)

    useEffect(()=>{
        setLoading(true)
        clinicService.getCustomization(clinicId)
        .then(res=>{
            setLoading(false)
            console.log(res.data)
            setCustomization(res.data)
        })
        .catch(err=>{
            setLoading(false)
            console.log("Error")
        })
    },[])

    const updateCustomization = (customValue) =>{
       // console.log("update Customizaion")
        setCustomization(customValue)
    }
  return (
    <>
        <div className='d-flex justify-content-between'>
                 <h5 className="card-title" style={{color:"#012970"}}> Clinic Customization</h5>
                            <div>
                                {isEditing ?
                                <button className="btn btn-secondary btn-sm mt-2"  onClick={()=>setIsEditing(false)}>  
                                    <i className="bi bi-x-square bi-sm"></i> Cancel
                                </button>
                                :
                                <button className="btn btn-secondary btn-sm mt-2" onClick={()=>setIsEditing(true)}>  
                                <i className="bi bi-pencil-square bi-sm"></i> Edit
                            </button>
                                }
                            </div>
        </div>
        <div className='row ms-2'>
            {loading ? <Loading/> :
                isEditing ? <CustomizationForm customization = {customization} updateCustomization = {updateCustomization}/>:
                    <>
                     <table className="table table-striped">
            <thead>
                <tr>
                    <th>#</th>
                    <th> Key</th>
                    <th> Value</th>
                </tr>
            </thead>
            <tbody>
            {
                    customization.map((item)=>{
                        return <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.optionKey}</td>
                                <td>{item.optionValue}</td>
                            </tr>

                    }) 
                }
            </tbody>
              
            
        </table>
                    </>
            }
        </div>
       
    </>
    )
}

export default CustomizationTab